import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

import MotifCheckbox from '@ey/motif-react-wrapper/Checkbox';

const Checkbox = ({label = null, className = null, ...rest}) => {
	const props = {
		...rest,
		className: classNames({[`${className}`]: !!className, ['no-label']: label === null})
	};

	if (label) props.children = label;

	return <StyledMotifCheckbox {...props} />;
};

Checkbox.propTypes = {
	label: PropTypes.string,
	className: PropTypes.string
};

export default Checkbox;

const StyledMotifCheckbox = styled(MotifCheckbox)`
	&.no-label {
		.motif-checkbox-label {
			display: none;
		}
	}
	&.motif-checkbox-wrapper {
		width: unset;
	}
	.motif-checkbox,
	.motif-checkbox-label {
		min-width: 0;
	}
`;
